/* 🤖 this file was generated by svg-to-ts */
export const iconCvx: {
  name: 'cvx';
  data: string;
} = {
  name: 'cvx',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m10.81 13.5h-6.63V11h-2.5V8.5h-3.37V11h-2.5v10h2.5v2.5h3.37V21h2.49v-2.5h6.63v5h-2.5V26h-5v2.5h-6.62V26h-5v-2.5h-2.5v-15h2.5V6h5V3.5h6.63V6h5v2.5h2.5z"/></svg>`,
};
